import { View } from "react-native";

export const Spacer = () => {
  return <View style={{ flexGrow: 1, flexShrink: 1 }} />;
};

export const DoubleSpacer = () => {
  return <View style={{ flexGrow: 2, flexShrink: 2 }} />;
};
